import { REQUEST_SERVICE_TYPES } from '../services/requestsApi';
import { getPublicationTypeLabel } from '../constants/publicationTypes';

export const SERVICE_TYPE_LABELS = REQUEST_SERVICE_TYPES.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export const PROVIDER_CATEGORIES = new Set([
  'ground_transport',
  'security_service',
  'suppliers',
  'logistics_operator',
  'road_assistance',
]);

export const truncate = (value, max = 160) => {
  if (!value) return '';
  if (value.length <= max) return value;
  return `${value.slice(0, max - 1).trim()}...`;
};

export const stripHtml = value => {
  if (!value) return '';
  return String(value)
    .replace(/<\/?[^>]+(>|$)/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const buildRequestFeedItem = request => ({
  id: request.id,
  kind: 'request',
  title: request.title,
  serviceType: request.serviceType || '',
  serviceTypeLabel: SERVICE_TYPE_LABELS[request.serviceType] || 'Servicio',
  company: request.company,
  creator: request.creator,
  companyId: request.companyId || request.company?.id || '',
  createdBy: request.createdBy || request.creator?.id || '',
  neededBy: request.neededBy,
  pickupLocation: request.pickupLocation,
  dropoffLocation: request.dropoffLocation,
  budget: request.budget,
  details: truncate(request.details, 220),
  rawDetails: request.details || '',
  created: request.created,
  updated: request.updated || request.created,
  status: request.status || '',
});

export const buildPublicationFeedItem = publication => ({
  id: publication.id,
  kind: 'publication',
  title: publication.title || publication.unitName || 'Publicacion',
  type: publication.type || '',
  companyId: publication.companyId || publication.company,
  companyName: publication.companyName || 'Proveedor',
  companyLogoUrl: publication.companyLogoUrl,
  companyHeroUrl: publication.companyHeroUrl,
  bannerUrl: publication.bannerUrl,
  productImageUrl: publication.productImageUrl,
  primaryImageUrl: publication.primaryImageUrl,
  location: publication.location,
  price: publication.price,
  typeLabel: getPublicationTypeLabel(publication.type),
  created: publication.created,
  updated: publication.updated || publication.created,
  unitName: publication.unitName,
  companySlug: publication.companySlug,
  numericId: publication.numericId || publication.id,
  unitPhotoUrl: publication.unitPhotoUrl,
  excerpt: truncate(stripHtml(publication.description || ''), 220),
  description: publication.description || '',
  createdBy: publication.createdBy || publication.company?.createdBy || '',
  updatedBy: publication.updatedBy || '',
  status: publication.status || '',
  companyCategory: publication.companyCategory || '',
});
